import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { DfteGridViewRoutingModule } from './dfte-grid-view-routing.module';
import { DConComponent } from './components/dcon-main/dcon-main.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DconAuthComponent } from '../../features/dfte-grid-view/config/dcon-authorization.component';
import { DconCredentialsComponent } from '../../features/dfte-grid-view/config/dcon-credentials.component';
import { DconFolderDetailsComponent } from '../../features/dfte-grid-view/config/dcon-folder-details.component';

@NgModule({
  declarations: [DConComponent,
    DconAuthComponent,
    DconCredentialsComponent,
    DconFolderDetailsComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  imports: [
    CommonModule,
    DfteGridViewRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [],
  entryComponents: [ DconFolderDetailsComponent ]
})
export class DfteGridViewModule { }
